import { Accordion, AccordionDetails, AccordionSummary, Alert } from "@mui/material";
import { useStyles } from "./MainAccordion.styles";
import { IMainAccordion } from "./MainAccordionInterfaces";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const MainAccordion = ({
    cardRef,
    title,
    children,
    fullWidth,
    unsavedChanges,
    disabled,
    defaultExpanded = true,
    defaultIsExpandedState = true,
}: IMainAccordion) => {
    const classes = useStyles();
    const [isExpanded, setIsExpanded] = useState<boolean>(defaultIsExpandedState);
    const handleCardExpandOrCollapse = () => {
        setIsExpanded(!isExpanded);
    };
    const { t } = useTranslation();

    return (
        <Accordion
            disabled={disabled}
            onChange={handleCardExpandOrCollapse}
            ref={cardRef}
            className={classes.card}
            defaultExpanded={defaultExpanded}
            sx={{ width: fullWidth ? "100%" : "initial" }}
        >
            <AccordionSummary className={classes.cardHeader}>
                <KeyboardArrowDownIcon
                    fontSize="small"
                    className={classes.cardHeaderIcon}
                    style={{ transform: isExpanded && !disabled ? "rotate(180deg)" : "rotate(0deg)" }}
                />
                <div className={classes.cardTitle}>{title}</div>
                {unsavedChanges ? (
                    <Alert className={classes.cardAlert} severity="info">
                        {t("accordion.unsaved_changes_message")}
                    </Alert>
                ) : null}
            </AccordionSummary>
            <AccordionDetails className={classes.cardBody}>
                {isExpanded && !disabled ? <div className={classes.cardBodyContent}> {children} </div> : null}
            </AccordionDetails>
        </Accordion>
    );
};

export default MainAccordion;
